import { render } from "./CardExpanded.vue?vue&type=template&id=707de5f9"
import script from "./CardExpanded.vue?vue&type=script&lang=js"
export * from "./CardExpanded.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__